<template>
  <div :class="$style.popup">
    <div :class="$style.content">
      <img :src="`${$cdnLink}/suspend/fuli/close.png`" alt="" @click="close">
      <p>正在为您跳转到{{ type=='bt'? 'BT盒子' : '玩心手游' }}app...</p>
      <p>如未自动打开app，请点击下方按钮</p>
      <button @click="download">点击前往{{ type=='bt'? 'BT盒子' : '玩心手游' }}app</button>
    </div>
  </div>
</template>

<script>
import { boxDownloadUrl, wxBoxDownloadUrl } from '@/config'
import { gameOpenDownloads } from '@/bridge/AppJsBridge';
import { buryReportV2 } from '@/libs/business/account';

export default {
  name: '',
  props: ['type'],
  data () {
    return {
    };
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    download() {
      buryReportV2('SDK_JUMP_BOX_BUTTON', '');
      gameOpenDownloads({
        gameUrl: this.type == 'bt' ? boxDownloadUrl() : wxBoxDownloadUrl()
      })
    },
    
  },
}
</script>

<style lang="scss" module>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1001;
  .content {
    width: 198px;
    height: 125px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/back.png');
    background-size: 100% 100%;
    font-size: 12px;
    text-align: center;
    padding-top: 40px;
    box-sizing: border-box;
    > img {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 10px;
      height: 10px;
    }
    > p {
      line-height: 18px;
      font-size: 12px;
      > span {
        color: #FF5B58;
      }
    }
    > button {
      margin-top: 10px;
      background: #FF5B58;
      font-size: 9px;
      border: none;
      width: 147px;
      height: 22px;
      color: #FFFFFF;
      line-height: 22px;
      border-radius: 22px;
    }
  }
}
</style>